import React, { Component } from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import AuthStore from '../../Auth/AuthStore';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import './report.css';
import { Button } from '@mui/material';
import DownloadIcon from '@mui/icons-material/CloudDownload';

export class MonthReport extends Component {

    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            month: 2,
            year: 2024
        };
        this.handleChange = this.handleChange.bind(this);

        //this.loadReport = this.loadReport.bind(this);
    }

    componentDidMount() {
        //this.loadReport();
    }

    downloadReport() {
    }

    handleChange = name => evt => {
        this.setState({ [name]: evt.target.value });
    }

    render() {
        return (
            <div>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Month</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={this.state.month}
                        onChange={this.handleChange('month')}
                        label="Month"
                    //onChange={handleChange}
                    >
                        <MenuItem value={0}>January</MenuItem>
                        <MenuItem value={1}>February</MenuItem>
                        <MenuItem value={2}>March</MenuItem>
                        <MenuItem value={3}>April</MenuItem>
                        <MenuItem value={4}>May</MenuItem>
                        <MenuItem value={5}>June</MenuItem>
                        <MenuItem value={6}>July</MenuItem>
                        <MenuItem value={7}>August</MenuItem>
                        <MenuItem value={8}>September</MenuItem>
                        <MenuItem value={9}>October</MenuItem>
                        <MenuItem value={10}>November</MenuItem>
                        <MenuItem value={11}>December</MenuItem>
                    </Select>
                </FormControl>

                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Year</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={this.state.year}
                        label="Year"
                    //onChange={handleChange}
                    >
                        <MenuItem value={2021}>2021</MenuItem>
                        <MenuItem value={2022}>2022</MenuItem>
                        <MenuItem value={2023}>2023</MenuItem>
                        <MenuItem value={2024}>2024</MenuItem>
                    </Select>
                </FormControl>

                <a href={'api/Schedulle/GetPeopleReport?month=' + this.state.month + '&year=' + this.state.year} download={'MonthReport_' + this.state.month + '_' + this.state.year + '_' + new Date().toLocaleDateString() + ".xlsx"}><DownloadIcon /></a>

            </div>
        )
    }
}